import TableField from "@/components/common/table-field/TableField.vue";

const defaultEl = {
    name: null,
    regNumber: null,
    balance: null
}
export default {
    name: 'Balance',
    components: {
        TableField
    },

    data() {
        return {
            client: defaultEl,
            invoices: [],
            params: {
                page: 1,
                pageSize: 20,
            },
            loading: true,
        }
    },

    computed: {
        companyId () {
            return this.$store.state.companyId;
        },
        columns() {
            return [
                { title: this.$t('balance.nr'), key: "contractNumber", sortable: true },
                { title: this.$t('balance.date'), key: "createdDate", sortable: true },
                { title: this.$t('balance.summa'), key: "totalPrice", sortable: true },
                { title: this.$t('balance.info'), key: "billingInfo", sortable: true }
            ]
        }
    },

    methods: {
        async populateData() {
            const savedPageSize = localStorage.getItem(`balance-page-size`);
            this.params.pageSize = savedPageSize != null ? Number(savedPageSize) : (this.params.pageSize != null ? Number(this.params.pageSize) : 20);
            this.loading = true;
            try {
                const params = {};
                if (this.companyId != null && this.companyId != '') {
                    params.companyId = this.companyId;
                }
                const response = await this.ApiRequest.requestAsync(
                    `billing/balance`,
                    this.ApiRequest.REQUEST_GET,
                    params,
                    'balance',
                    true
                );

                if (!response || response.error || response.canceled) return;
                const { data } = response;
                this.client = data.client == null ? defaultEl : this.BasicHelper.cloneObject(data.client);
                this.invoices = this.BasicHelper.cloneObject(data.invoices);
            } finally {
                this.loading = false;
            }
        }
    },

    beforeMount() {
        this.populateData();
    },

    watch: {
        companyId() {
            this.populateData();
        }
    }
}